var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5715 0C5.07895 0 4.60658 0.193781 4.2583 0.538714C3.91002 0.883647 3.71436 1.35148 3.71436 1.83929V9.19643C3.71436 9.68424 3.91002 10.1521 4.2583 10.497C4.60658 10.8419 5.07895 11.0357 5.5715 11.0357H11.1429C11.6355 11.0357 12.1078 10.8419 12.4561 10.497C12.8044 10.1521 13.0001 9.68424 13.0001 9.19643V4.0593C13 3.57153 12.8042 3.10378 12.4559 2.75893L10.2144 0.538911C9.86615 0.193954 9.39386 0.000104172 8.90136 0H5.5715Z",
    fill: "#657B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.51786C0 5.03005 0.195663 4.56222 0.543944 4.21729C0.892226 3.87235 1.3646 3.67857 1.85714 3.67857V12.875H9.28571C9.28571 13.3628 9.09005 13.8306 8.74177 14.1756C8.39349 14.5205 7.92112 14.7143 7.42857 14.7143H1.85714C1.3646 14.7143 0.892226 14.5205 0.543944 14.1756C0.195663 13.8306 0 13.3628 0 12.875V5.51786Z",
    fill: "#657B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAlt);
export default __webpack_public_path__ + "static/media/copy-alt.7183d72ff492f42a88b2406e5ca2a2c2.svg";
export { ForwardRef as ReactComponent };